import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'

// Components
import SubscriptionLocked from 'app/views/components/Subscription/SubscriptionLocked'

// Containers
import BrowserSkillArea from 'app/views/containers/BrowserSkillArea'

// Redux
import { getContentById } from 'app/state/modules/content'

// Settings
import settings from 'settings'

// Utils
import analytics from 'app/views/utils/analytics'
import { api } from 'app/views/utils/api'
import isMobileDevice from 'app/views/utils/mobile'


const propTypes = {
  idToken: PropTypes.string.isRequired, // mapStateToProps
  baseUrl: PropTypes.string, // mapStateToProps
  match: PropTypes.object.isRequired, // withRouter
}
const defaultProps = {
  browserUrl: '',
}

class ContentDetail extends React.Component {
  constructor(props) {
    super(props)

    this.trackProgress = this.trackProgress.bind(this)
    this.handleClickBack = this.handleClickBack.bind(this)
    this.handleClickCircle = this.handleClickCircle.bind(this)
    this.handleClickDone = this.handleClickDone.bind(this)
    this.handleClickNext = this.handleClickNext.bind(this)
  }

  componentDidMount() {
    this.props.getContentById(this.props.match.params.id)

    analytics.page('page-lesson', {
      id: this.props.match.params.id,
      contentType: 'course',
    })
  }

  trackProgress(stepNumber) {
    api({
      method: 'post',
      url: `${settings.urls.hacker}/user/${this.props.profile.user_id}/content/${this.props.match.params.id}`,
      idToken: this.props.idToken,
      data: {
        step_number: stepNumber,
      },
    })
      .catch((error) => {
        console.error('error posting progress: ', error)
      })
  }

  handleClickBack(stepIndex) {
    this.trackProgress(stepIndex)
    analytics.track('click-step-back', {
      lessonId: this.props.match.params.id,
      taskId: this.props.contentDetails[this.props.match.params.id].ecs_task_definition,
      stepIndex,
    })
  }

  handleClickCircle(stepIndex) {
    this.trackProgress(stepIndex)
    analytics.track('click-step-dotnav', {
      lessonId: this.props.match.params.id,
      taskId: this.props.contentDetails[this.props.match.params.id].ecs_task_definition,
      stepIndex,
    })
  }

  handleClickDone(stepIndex) {
    this.trackProgress(stepIndex)
    analytics.track('click-step-done', {
      lessonId: this.props.match.params.id,
      taskId: this.props.contentDetails[this.props.match.params.id].ecs_task_definition,
    })
  }

  handleClickNext(stepIndex) {
    this.trackProgress(stepIndex)
    analytics.track('click-step-next', {
      lessonId: this.props.match.params.id,
      taskId: this.props.contentDetails[this.props.match.params.id].ecs_task_definition,
      stepIndex,
    })
  }

  render() {
    const content = this.props.contentDetails[this.props.match.params.id]
    if (
      !Object.keys(this.props.contentDetails).includes(this.props.match.params.id)
      || this.props.license === null
    ) {
      return (
        <div className="uk-section uk-text-center">
          <div className="uk-container">
            <div data-uk-spinner="" />
          </div>
        </div>
      )
    }

    if ((content.requires_subscription === true && this.props.license === false)
      || (content.requires_subscription === true && content.license_out_of_scope)
      || (content.requires_subscription === true && content.is_expired)
    ) {
      return (
        <SubscriptionLocked
          isExpired={content.is_expired}
          licenseOutOfScope={content.license_out_of_scope}
          contentType={content.content_type}
        />
      )
    }

    if (isMobileDevice()) {
      return (
        <div className="uk-section">
          <div className="uk-container uk-text-center">
            <h3 className="uk-text-bold">Looks like you're on mobile...</h3>
            <p>
              We're glad you're checking out a lesson while on the go, but our tools are not
              available on mobile.
            </p>
            <Link className="uk-button uk-button-primary" to="/">Back To Dashboard</Link>
          </div>
        </div>
      )
    }

    return (
      <BrowserSkillArea
        handleClickBack={(stepIndex) => { this.handleClickBack(stepIndex) }}
        handleClickCircle={(stepIndex) => { this.handleClickCircle(stepIndex) }}
        handleClickDone={(stepIndex) => { this.handleClickDone(stepIndex) }}
        handleClickNext={(stepIndex) => { this.handleClickNext(stepIndex) }}
        title={content.title}
        description={content.description}
        steps={content.steps}
        tabs={content.tabs}
        ecsTaskDefinition={content.ecs_task_definition}
        currentProgress={content.current_progress}
        hasTest={content.has_test}
        appType={content.app_type}
        contentType={content.content_type}
        lessonCompletionURL="/"
        lessonCompletionText="Start your next lesson"
        userId={this.props.profile.user_id}
      />
    )
  }
}

ContentDetail.propTypes = propTypes
ContentDetail.defaultProps = defaultProps

const mapStateToProps = (state) => ({
  // auth
  idToken: state.auth.user.idToken,

  // content
  contentDetails: state.content.contentDetails,

  // hacker
  license: state.hacker.license,
  profile: state.hacker.profile,
})

const mapDispatchToProps = (dispatch) => ({
  getContentById: (contentId) => dispatch(getContentById(contentId)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ContentDetail))
